import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

export const FAQSection = ({ faqs, title = "Pool service questions, answered", overline = "FAQ" }) => (
  <section data-testid="faq-section" className="py-16 sm:py-24 lg:py-32 bg-shell">
    <div className="px-4 sm:px-6 lg:px-12 max-w-3xl mx-auto">
      <Reveal className="text-center">
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-pool font-semibold">{overline}</p>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] text-navy">
          {title}
        </h2>
      </Reveal>

      <Reveal delay={0.12}>
        <Accordion type="single" collapsible className="mt-10 space-y-3.5">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-slate-200/80 rounded-2xl px-6 data-[state=open]:shadow-lg data-[state=open]:shadow-cyan-500/5 transition-shadow duration-300"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display font-semibold text-navy text-base sm:text-lg tracking-tight py-5 hover:no-underline hover:text-pool transition-colors"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-slate-600 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
